class ConfirmationController {
  constructor (Localization, ProductService, VehicleService, UserService, PaymentService,
               $window, $location, $stateParams, $log, I18n, $rootScope, $scope, StoreTypes)
  {
    'ngInject'
    this.isProcessing = true
    this.$stateParams = $stateParams
    this.productService = ProductService
    this.vehicleService = VehicleService
    this.userService = UserService
    this.i18n = I18n
    this.$location = $location
    this.$window = $window
    this.paymentService = PaymentService
    this.$log = $log
    this.$scope = $scope
    this.$rootScope = $rootScope
    this.StoreTypes = StoreTypes
    this.Localization = Localization
    this.activeTab = 'confirmation'
    this.init()
    this.validatePayment()
  }

  init () {
    if (!this.$stateParams.free && !this.$stateParams.direct) {
      this.pspType = this.userService.getPspType()
      this.$location.url(this.$window.location.pathname + this.$window.location.search)
      this.status = this.$location.search().status
      if (this.pspType === 'WORLDPAY') {
        // case WORLDPAY
        this.order = this.$location.search().order
        this.amount = this.$location.search().amount
        this.currency = this.$location.search().currency
      } else {
        // case SIPS
        this.isPurchaseVoucher = this.$location.search().voucher === 'true'
        this.amountReduction = this.$location.search().reduction
      }
    }
  }

  validatePayment () {
    // Case Free Product OR direct payment Worldpay
    if (this.$stateParams.free || this.$stateParams.direct) {
      this.status = this.$stateParams.status
      this.productRef = this.$stateParams.productId
      this.isPurchaseVoucher = this.$stateParams.voucher
      this.isDirectPayment = this.$stateParams.direct
      this.amountReduction = this.$stateParams.reduction
      this.manageConfirmation()
    } else {
      this.pspType = this.userService.getPspType()
      if (this.pspType === 'SIPS') {
        if (this.isInPaymentIFrame()) {
          this.$log.error('We shouldn\'t be in an iframe here')
          this.isProcessing = false
        } else {
          this.productRef = this.$stateParams.productId
          this.manageConfirmation()
        }
        if (this.Localization.getLocalizedAppConfig().type === this.StoreTypes.HELIOS ||
          this.Localization.getLocalizedAppConfig().type === this.StoreTypes.MYRENAULT ||
          this.Localization.getLocalizedAppConfig().type === this.StoreTypes.ONE) {
          this.$window.localStorage.removeItem('token')
        }
      }
      if (this.pspType === 'WORLDPAY') {
        this.paymentService.validatePaymentWorldpay(
          this.order,
          this.status,
          this.amount,
          this.currency,
          this.$stateParams.mac
        ).then((res) => {
          this.isPurchaseVoucher = res.isPurchaseVoucher
          this.amountReduction = parseFloat(res.amountReduction).toFixed(2) + ' ' + this.$stateParams.currency
          this.status = res.status
          this.productRef = res.productRef
          this.transactionId = res.transactionId
          this.manageConfirmation()
        }, (err) => {
          this.$log.error('error validatePayment Worldpay', err)
          this.error = err
          this.isProcessing = false
          this.safeApply()
        })
      }
    }
  }

  manageConfirmation () {
    if (this.status === 'Delivered' || this.status === 'AUTHORISED' || this.status === 'CSDBError') {
      return this.vehicleService.getCurrentSelectedVehicle()
      .then((vehicle) => {
        return this.productService.getProduct(this.productRef, vehicle.vin, this.i18n.getLanguage())
      })
      .then((product) => {
        this.product = product
        if (this.product.isPromoted) {
          this.pricePay = this.product.promotedPrice
        } else {
          this.pricePay = this.product.price
        }
        if (parseFloat(this.amountReduction) === 0) {
          this.amountReduction = 'confirmation.product.free'
        }
        this.isProcessing = false
        this.productService.initCache()
        this.safeApply()
      }, (err) => {
        this.$log.error('error manageConfirmation', err)
        this.error = err
        this.isProcessing = false
        this.safeApply()
      })
    } else {
      this.$log.debug('debug manageConfirmation', this.status)
      this.isProcessing = false
      this.safeApply()
    }
  }

  isInPaymentIFrame () {
    return window.top !== window && window.name === 'iframe_payment'
  }

  safeApply () {
    const phase = this.$rootScope.$$phase
    if (phase !== '$apply' && phase !== '$digest') {
      this.$scope.$apply()
    }
  }
}

export default ConfirmationController



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/confirmation/confirmation.controller.js